import { BUTTONS_SHARE } from '@lib/constants';
import { useRouter } from 'next/router';

import { useSelector } from 'react-redux';
import style from '../index.module.scss';
import Btn from '@components/Btn';

import { useI18n } from '@lib/i18n';

export default function SaveAndShareSticky({ classes, isAdvisorView = false }) {
	const router = useRouter();
	const { t } = useI18n();

	const { authenticated } = useSelector((state) => state.user);

	const hideHeaderButtonsForViews = [
		'/auth/login',
		'/auth/register',
		'/auth/personalise',
		'/advisor',
		'/personalise',
		'/share',
		'/configure',
	];

	if (hideHeaderButtonsForViews.includes(router.pathname)) {
		return;
	}

	if (!authenticated) {
		return;
	}

	const shareProspectus = () => {
		router.push('/share');
	};

	if (isAdvisorView) {
		return;
	}

	return (
		<>
			<Btn disabled={!authenticated} onClick={() => shareProspectus()} customClass={classes}>
				<svg
					className="mobile-only"
					overflow="visible"
					preserveAspectRatio="none"
					viewBox="0 0 24 24"
					width="24"
					height="24"
				>
					<path
						id="share-square-o"
						d="M17.99,14.3c0-0.14-0.09-0.26-0.22-0.3c-0.12-0.06-0.27-0.02-0.36,0.08c-0.17,0.16-0.35,0.29-0.56,0.39  c-0.12,0.05-0.19,0.17-0.19,0.3V17c-0.01,0.92-0.75,1.66-1.67,1.66H6.33c-0.92,0-1.66-0.74-1.67-1.66V8.34  c0-0.92,0.75-1.67,1.67-1.67l0,0h1.16c0.06,0.01,0.11,0.01,0.17,0C8.1,6.4,8.56,6.17,9.04,6c0.16-0.02,0.29-0.16,0.27-0.33  c0,0,0,0,0,0c0-0.18-0.14-0.32-0.32-0.33H6.33c-0.8-0.01-1.57,0.31-2.12,0.88C3.64,6.77,3.32,7.54,3.33,8.34V17  c-0.01,0.8,0.31,1.57,0.88,2.12c0.55,0.57,1.32,0.89,2.12,0.88h8.66c1.66,0,3-1.34,3-3V14.3L17.99,14.3z M20.46,9.14  c0.26-0.25,0.27-0.66,0.02-0.92c-0.01-0.01-0.01-0.01-0.02-0.02l-4-4C16.34,4.07,16.17,4,15.99,4c-0.09,0-0.18,0.02-0.26,0.05  c-0.26,0.09-0.42,0.34-0.41,0.61v2h-1.66c-0.67,0-1.34,0.03-2,0.11C11.1,6.84,10.54,6.95,9.99,7.1c-0.45,0.12-0.89,0.29-1.3,0.5  C8.34,7.78,8,7.99,7.69,8.24C7.43,8.46,7.19,8.72,6.99,9C6.8,9.27,6.64,9.55,6.5,9.85c-0.13,0.3-0.22,0.6-0.29,0.92  c-0.07,0.31-0.12,0.62-0.15,0.94c0,0.29,0,0.61,0,0.95c0.01,0.43,0.07,0.86,0.18,1.27c0.1,0.41,0.24,0.8,0.4,1.19  c0.15,0.33,0.32,0.67,0.52,1c0.2,0.33,0.34,0.57,0.41,0.71l0.15,0.37c0.06,0.09,0.16,0.14,0.27,0.14h0.12  c0.14-0.05,0.24-0.19,0.22-0.34c-0.31-2.33-0.06-3.97,0.77-4.92c0.83-0.95,2.35-1.4,4.56-1.36h1.67v2  c-0.01,0.27,0.15,0.52,0.41,0.61c0.08,0.03,0.17,0.05,0.26,0.05c0.18,0,0.35-0.07,0.47-0.2l4-4l0,0L20.46,9.14z"
						fill="currentColor"
						vectorEffect="non-scaling-stroke"
					/>
				</svg>
				<span className={style.text}>{t('header.share', BUTTONS_SHARE)}</span>
				{!authenticated && <span className="tooltip-text">{}</span>}
			</Btn>
		</>
	);
}
